import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.EntregaIngresosAUsuarioDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Proveedor", cell: x => ({ data: x.NombreUsuario }) },
    { title: "Usuario Capturo", cell: x => ({ data: x.NombreUsuarioCapturo }) },
    { title: "Fecha", cell: x => ({ data: kea.formatDate(x.Fecha) }) },
    { title: "Monto", cell: x => ({ data: kea.formatCurrency(x.Monto) }) },
    

    { title: "Factura", cell: x => ({ data: x.Factura }) },
    { title: "Forma de pago", cell: x => ({ data: x.FormaPagoSat }) },
    { title: "Cuenta", cell: x => ({ data: x.CuentaBancaria }) },
    { title: "Cancelada", cell: x => ({ data: x.EsCancelada }) },
    { title: "Motivo Cancelación", cell: x => ({ data: x.MotivoCancelacion }) },
    { title: "Usuario Cancelo", cell: x => ({ data: x.NombreUsuarioCancelo }) },
];

export interface BotonesDeps {
    onCancelar: (item: Entity) => void;
    onGenerarReporte: (item: Entity) => void;
    onVer: (x: Entity) => void;
}

function botones(deps: BotonesDeps, permisos: models.Rol): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([

        {
            tooltip: "Cancelar entrega ingreso",
            style: "primary",
            iconClass: fa("times-circle-o"),
            onClick: deps.onCancelar,
            disabled: x => x.EsCancelada || !permisos.EntregaIngresosUsuarioZE.VerBotonCancelarEntrega
        },
        {
            tooltip: "Generar reporte de entrega ingreso",
            style: "success",
            iconClass: fa("file-pdf-o"),
            onClick: deps.onGenerarReporte,
            disabled: x => !permisos.EntregaIngresosUsuarioZE.VerBotonGenerarReporte
        }
    ]);

    return {
        ...columna,
        cell: x => ({
            ...columna.cell(x),
            style: () => ({
                maxWidth: "350px"
            })
        })
    }
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps, permisos: models.Rol): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps, permisos), ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/entregaingresoZE/list/columns.tsx